export const GAME_VERSION = "0.7.1c";
export const COMPATIBLE_VERSIONS = ["0.7.1a,0.7.1b"];